<template>
    <div class="dlkj">
		<div class="rhjss" @click="returnBack" v-if="detail">接口账单/<span>查看详情</span></div>
		
        <secret @orderId="getOrderId"></secret>
		<div class="bujss" v-loading="tableLoading">
			<div v-if="!detail">
				<h6 class="joid">账单列表</h6>
				<!-- <div class="juidj">
					<el-date-picker
					  v-model="date"
					  type="daterange"
					  range-separator="至"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期">
					</el-date-picker>
					<div @click="getCase" :class="['rtgh',{'rtgh-diabled': !date}]" :disabled="!date">查询</div>
				</div> -->
			</div>
			<div class="tgns" v-if="detail">
				<el-input
					placeholder="请输入接口名称"
					clearable
					v-model="input1">
					<i @click="getSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</div>
			<div class="ryyh" v-if="!detail">
				<el-table
				    :data="tableData"
				    style="width: 100%">
				    <el-table-column
				      label="调用月份"
				      width="140">
					  <template slot-scope="scope">
						{{ scope.row.invokeMonth }}
					  </template>
				    </el-table-column>
				    <el-table-column
				      label="调用次数（次）"
				      width="200">
				      <template slot-scope="scope">
						{{ scope.row.invokeNum }}
				      </template>
				    </el-table-column>
					<!-- <el-table-column
					  label="实际付费次数（次）"
					  width="200">
					  <template slot-scope="scope">
							{{ scope.row.paidNum }}
					  </template>
					</el-table-column> -->
					<el-table-column
					  label="实际扣费金额（元）"
					  width="180">
					  <template slot-scope="scope">
						{{ scope.row.actualCost }}
					  </template>
					</el-table-column>
				    <el-table-column label="操作" width="194">
				      <template slot-scope="scope">
				        <span class="guuus" @click="handleEdit(scope.$index, scope.row)">查看详情</span>
				      </template>
				    </el-table-column>
				  </el-table>
  <div class="wdwds" v-if="tableData.length===0">
  <img src="../../../assets/kong/kong_.png" alt=""/>
  <p>暂无接口账单</p>
			  </div>
			</div>
			
			<div class="ryyh" v-if="detail">
				<el-table
				    :data="tableDetail"
				    style="width: 100%">
					<el-table-column
					  label="接口名称"
					  width="180">
					  <template slot-scope="scope">
						{{ scope.row.intfName }}
					  </template>
					</el-table-column>
				    <el-table-column
				      label="总调用次数（次）"
				      width="160">
					  <template slot-scope="scope">
						{{ scope.row.invokeNum }}
					  </template>
				    </el-table-column>
				    <el-table-column
				      label="成功调用次数（次）"
				      width="190">
				      <template slot-scope="scope">
						{{ scope.row.successNum }}
				      </template>
				    </el-table-column>
					<!-- <el-table-column
					  label="实际付费次数（次）"
					  width="180">
					  <template slot-scope="scope">
							{{ scope.row.paidNum }}
					  </template>
					</el-table-column> -->
					<el-table-column
					  label="实际扣费金额（元）"
					  width="206">
					  <template slot-scope="scope">
						{{ scope.row.actualCost }}
					  </template>
					</el-table-column>
				  </el-table>
  <div class="wdwds" v-if="tableDetail.length===0">
  <img src="../../../assets/kong/kong_.png" alt=""/>
  <p>暂无接口详情</p>
			  </div>
			  <div v-if="pages>10" class="erfr">
			  	<el-pagination
			  		background	
			  		:current-page="currentPage"
			  	    layout="prev, pager, next"
			  		@current-change="handleCurrentChange"
			  	    :total="pages">
			  	  </el-pagination>
			  </div>
			</div>
			
		</div>
        <router-view></router-view>
    </div>
</template>
<script>
import secret from '../../../components/secret.vue'
import { orderApi } from '@/api'
export default {
    namme:'case3',
	components:{
	  secret
	},
    data(){
        return{
            // list:[],
            // caseId:'',
			// ifSee: true,
			input1: '',
			tableLoading: false,
			date: '',
			detail: false,
			orderId: '',
			// img1: require('../../../assets/common/ddd.png'),
			// img2: require('../../../assets/common/ddd_.png'),
			// options01: [{
			//   value: 1,
			//   label: '套餐1'
			// }, {
			//   value: 2,
			//   label: '套餐2'
			// }],
			// filters01: '',
			// filters02: '',
			tableData: [],
			pages: 0,
			currentPage: 1,
			rowObj: {},
			tableDetail: []
        }
    },
    methods:{
		returnBack() {
			this.detail=false;
			this.$cookies.remove('obj')
			this.getCase()
		},
		getOrderId(val) {
			if(!val) {
			  this.orderId = ''
			  this.tableData = []
			  this.tableDetail = []
			  return
			}
			this.orderId = val
			if(this.detail) {
				this.getDetail(this.rowObj,1)
			} else {
				this.getCase()
			}
		},
		getCase:function(page){
		    let params = {
				  orderId: this.orderId
				  // name: this.input1,
				  // date: this.date,
				  // pageNum: page || 1
			  }
			this.tableLoading = true
		    orderApi.getInvokeStatistics(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					
				  } else {
					this.$message.error(res.message);
				  }
				  try{
				  	this.tableData = res.data
					console.log(this.tableData)
				  }catch(e){
				  	//TODO handle the exception
				  }
				  this.tableLoading = false
			  })
			  .catch(err=>{
				  this.tableLoading = false
				  alert(err);
			  })
		},
		getSearch() {
			this.getDetail(this.rowObj,1)
		},
		getDetail(row,page) {
			this.tableLoading = true
			// 切换后初始化数据
			// this.date = ''
			// this.input1 = ''
			let _this = this
			let params = {
				  orderId: this.orderId || row.orderId,
				  intfName: row.intfName,
				  month: row.invokeMonth,
				  intfName:this.input1,
				  pageNum: page
			  }
			orderApi.getInvokeStatisticsDetail(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.detail = true
					this.$cookies.set('obj', row, { expires: 1 })
				  } else {
					this.$message.error(res.message);
				  }
				  try{
				  	this.tableDetail = res.data.records
					this.pages = res.data.total
				  }catch(e){
				  	//TODO handle the exception
				  }
				  this.tableLoading = false
			  })
			  .catch(err=>{
				  this.tableLoading = false
				  alert(err);
			  })
		},
		handleCurrentChange(val) {
			this.getDetail(this.rowObj,val)
		},
		handleEdit(index, row) {
			this.getDetail(row,1)
			this.rowObj = row
		  },
		  handleDelete(index, row) {
			console.log(index, row);
		  }
    },
	beforeDestroy() {
		this.$cookies.remove('obj')
	},
    mounted() {
    	this.$store.commit('setCenterIndex',3)
		let obj = this.$cookies.getJSON('obj')
		if (obj && obj.orderId) {
			this.rowObj = obj
			this.input1 = ''
			this.getDetail(obj,1)
			this.detail = true
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/views/center/caseChild/case4.vue